import { Button, Drawer, Form, Input, Select, Space } from "antd";
import React from "react";
import { connect } from "react-redux";
import {
  createInventorySubCategory,
  fetchInventoryCategories,
} from "../../../../../api/inventory.api";

const AddSubCategoryDialog = ({ open, onClose, settings, refresh }) => {
  const [categories, setCategories] = React.useState([]);
  const [form] = Form.useForm();

  const getCategories = React.useCallback(async () => {
    try {
      const categories = await fetchInventoryCategories();
      setCategories(categories);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const submit = React.useCallback(
    async (values) => {
      try {
        const data = {
          ...values,
          branch: settings?.branch?.id,
        };
        await createInventorySubCategory(data);
        refresh();
        form.resetFields();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
    [form, onClose, refresh, settings?.branch?.id]
  );

  React.useEffect(() => {
    getCategories();
  }, [getCategories]);

  return (
    <Drawer
      title="Add sub category"
      open={open}
      visible={open}
      extra={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={form.submit}>
            Save
          </Button>
        </Space>
      }
      onClose={onClose}
    >
      <Form form={form} layout="vertical" onFinish={submit}>
        <Form.Item
          label="Parent Category"
          name="inventory_category"
          rules={[
            {
              required: true,
              message: "Please select a category",
            },
          ]}
        >
          <Select>
            {categories.map((category) => (
              <Select.Option value={category.id}>
                {category.category_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Sub Category Name"
          name="subcategory_name"
          rules={[
            {
              required: true,
              message: "Please enter a sub category name",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

const mapStateToProps = (state) => {
  return {
    settings: state.settings,
  };
};

export default connect(mapStateToProps)(AddSubCategoryDialog);
